"use client";

import { c as _c } from "react/compiler-runtime";
import type { PersonalizedViewProps } from "@/app/_components/LivePersonalizedEntry";
import type { CtaVariantData } from "@/lib/ninetailed/mapCtaExperiences";
import CTAButton, { type CtaButtonEntry } from "./CTAButton";
export type CtaFields = CtaVariantData["fields"];
interface Props extends PersonalizedViewProps<CtaFields> {
  className?: string;
}
export const CTAButtonView = t0 => {
  const $ = _c(10);
  const {
    fields,
    inspectorProps,
    className
  } = t0;
  let t1;
  if ($[0] !== fields) {
    t1 = "externalUrl" in fields ? {
      sys: {
        id: "personalized-cta",
        contentType: {
          sys: {
            id: "externalButton"
          }
        }
      },
      fields
    } : {
      sys: {
        id: "personalized-cta",
        contentType: {
          sys: {
            id: "button"
          }
        }
      },
      fields
    };
    $[0] = fields;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const entry = t1;
  let t2;
  if ($[2] !== inspectorProps) {
    t2 = inspectorProps("buttonText");
    $[2] = inspectorProps;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className || $[5] !== entry) {
    t3 = <CTAButton entry={entry} className={className} />;
    $[4] = className;
    $[5] = entry;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div {...t2}>{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};